// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"111":"6f4bb2b1","452":"35db3000"}[chunkId] + ".1792712899448.chunk.css";
};